import {
  BILLS_SUCCESS,
  ACCOUNTS_LOADING,
  SET_ROLE_PERMISSIONS_LOADING,
  SET_ROLE_PERMISSIONS_STATUSES,
  SET_ROLE_PERMISSIONS_ACCOUNT_RESTRICTED_EVENTS,
  SET_ROLE_PERMISSIONS_SUPPORT_FILE_RESTRICTIONS,
  SET_FILTERS_CONFIGURATION,
  SET_SELECTED_DATE,
  SET_SELECTED_ACCOUNT,
  SET_ACCOUNT_CHARGES,
  SET_ACCOUNT_CHARGES_LOADING,
  SET_SUPPORT_FILES_LOADING,
  SET_SUPPORT_FILES_BY_CHARGE,
  SET_SUPPORT_FILES_BY_ACCOUNT,
  SET_ALL_SUPPORT_DOCUMENT_FILES,
  SET_SELECTED_CHARGE,
  SET_COMMENTS_ACCOUNT,
  SET_AGRREMENTS_LOADING,
  SET_AGREMENTS,
	SET_PROVIDER_AGREEMENTS,
  SET_PROVIDER_SUPPORT_DOCUMENTS,
  SET_PAYERS,
  SET_SELECTED_AGREEMENT,
  SET_AGREEMENT_CONFIGURATION,
  SET_SELECTED_AUDIT_RULE,
  SET_HEALTHCARE_PLANS,
  SET_SERVICE_SUPPORT_DOCUMENTS_LOADING,
  SET_SERVICE_SUPPORT_DOCUMENTS_ACCOUNT,
  SET_SERVICE_SUPPORT_DOCUMENTS_CHARGE,
  SET_SUPPORT_FILE_TYPES,
  SET_AGREEMENT_PRODUCTS_LOADING,
  SET_AGREEMENT_PRODUCTS,
  SET_DISPLAY_DIALOG_COMMENT,
  SET_COMMENT_CONTROL,
  SET_PAYERS_AVAILABLE,
  SET_IS_INVOICED_AND_IS_CONCURRENT_ACCOUNT,
  SET_ROLE_RCM_USER,
  SET_PROVIDER_SERVICE_TYPES,
  SET_ACCOUNT_LIST_SORT,
  SET_AGREEMENT_FILTERS,
  SET_PRE_SETTLEMENTS,
  SET_PRE_SETTLEMENTS_FILTER,
  SET_PRE_SETTLEMENTS_DETAIL,
  SET_ACCOUNTS_SEARCH_VALUE,
  SET_ACCOUNT_CHARGES_FILTER,
  SET_IS_MULTI_PATIENT_ACCOUNT,
  SET_IS_MULTI_EVENT_SAME_PATIENT_ACCOUNT,
  SET_SUPPORT_DOCUMENTS_LOADING,
  SET_SUPPORT_DOCUMENTS,
  SET_SUPPORT_FORMAT_FILE_FIELDS,
  SET_PROVIDER_PRODUCTS,
  SET_PROVIDER_PRODUCTS_SEARCH_VALUE,
  SET_PROVIDER_PRODUCTS_LOADING,
  SET_PROVIDER_PRODUCT_CONFIGURATION_DIALOG,
  SET_SELECTED_PROVIDER_PRODUCT,
  SET_SELECTED_PROVIDER_PRODUCT_CONFIGURATION,
  SET_PROVIDER_EXECUTOR_SERVICES,
  SET_PROVIDER_AGREEMENT_PLAN_TYPES,
  SET_PROVIDER_INVOICE_SOURCES,
  SET_ACCOUNT_DEFAULT_FILTERS_VALUES_APPLIED,
  SET_PRE_SETTLEMENT_FOLDER_CONFIGURATION,
  SET_UPLOADED_AGREEMENT_MATRIX,
  SET_UPLOADED_AGREEMENT_MATRIX_LOADING,
  SET_UPLOAD_AGREEMENT_MATRIX_RESULT,
  SET_UPLOAD_AGREEMENT_MATRIX_RESULT_LOADING,
  SET_SELECTED_ACCOUNTS,
  SET_USERS,
  REASSIGNED_BILLS_SUCCESS,
  REASSIGNED_ACCOUNTS_LOADING,
} from './mutation-types'

import {
  getAccounts,
  getRolePermissionsStatuses,
  getRolePermissionsAccountRestrictedEvents,
  getRolePermissionsSupportFileRestrictions,
  getAccountCharges,
  getDetailAccount,
  getAllSupportFiles,
  uploadSupportFileByEvent,
  getDetailCharge,
  getAuditComment,
  deleteSupportFileByEvent,
  getAgreements,
  getAgreementsV2,
	getAllAgreements,
  getProviderSupportDocuments,
  getPayers,
  getAgreementConfiguration,
  updateAgreement,
  createOrUpdateComment,
  getHealthcarePlans,
  getAgreementServiceSupportDocuments,
  getAgreementProductSupportDocuments,
  getSupportFileTypes,
  getAgreementProducts,
  changeAccountStatus,
  getProviderServiceTypes,
  getProviderExecutorServices,
  getProviderAgreementPlanTypes,
  getPreSettlements,
  getPreSettlementsDetail,
  getSupportFiles,
  getSupportFormatFileFields,
  getProviderProducts,
  updateProviderProducts,
  getProviderInvoiceSources,
  updatePreSettlementFolder,
  getPreSettlementFolderConfiguration,
  getUploadedAgreementMatrix,
  uploadAgreementMatrix,
  buildPreSettlement,
  settlementAction,
  statusPreSettlement,
  getUsers,
  assignAccountResponsible,
  replaceSupportFileForPreSettlement,
  cleanPackageFolder
} from '../../services/rcm-api.service'

import {
  sanitizeEndpointError,
  filterStatusByRoleStatusPermissions,
  updateFilter
} from '@/utils'

import vueI18n from '@/plugins/vue-i18n'
import { camelizeKeys, decamelizeKeys } from 'humps'

const getAllAccounts = async ({ commit, dispatch }, filters) => {
  commit(ACCOUNTS_LOADING, true)
  showLoader({ dispatch }, true)
  try {
    const response = await getAccounts(filters)
    commit(BILLS_SUCCESS, camelizeKeys(response.data))
    commit(ACCOUNTS_LOADING, false)
    showLoader({ dispatch }, false)
  } catch (error) {
    commit(ACCOUNTS_LOADING, false)
    showLoader({ dispatch }, false)
  }
}

const getAllReassignedAccounts = async ({ commit, state, dispatch }, filters) => {
  commit(REASSIGNED_ACCOUNTS_LOADING, true)
  showLoader({ dispatch }, true)
  try {
    const selectedAccount = state.accountDetail.selectedAccount
    const response = await getAccounts({ ...filters, reassignedAccountId: selectedAccount.accountId })

    commit(REASSIGNED_BILLS_SUCCESS, camelizeKeys(response.data))
    commit(REASSIGNED_ACCOUNTS_LOADING, false)
    showLoader({ dispatch }, false)
  } catch (error) {
    commit(REASSIGNED_ACCOUNTS_LOADING, false)
    showLoader({ dispatch }, false)
  }
}

const setFiltersConfiguration = async ({ commit, rootGetters, getters, state }) => {
  const rolePermissionsStatuses = [...state.rolePermissions.statusesPermissions]

  const filtersByRoleStatusPermissions = filterStatusByRoleStatusPermissions(
    rolePermissionsStatuses
  )

  const { rcmUserRoles } = rootGetters.tokenExtensions;
  commit(SET_ROLE_RCM_USER, rcmUserRoles)

  if (rcmUserRoles === 'EXTERNAL_AUDITOR'){
    const modifyFilters = filtersByRoleStatusPermissions.filter( filters => filters.category !== 'rcm-status-concurrent')
    commit(SET_FILTERS_CONFIGURATION, modifyFilters)
    return
  }

  filtersByRoleStatusPermissions.map((filter) => {
    switch (filter.category) {
      case 'rcm-account-service-types':
        filter.items = getters.providerServiceTypes
        break;
      case 'rcm-account-executor-services':
        filter.items = getters.providerExecutorServices
        break;
      case 'rcm-account-agreement-plan-types':
        filter.items = getters.providerAgreementPlanTypes
        break;
      case 'rcm-invoice-sources':
        filter.items = getters.providerInvoiceSources
        break;
      case 'rcm-provider-agreement':
        filter.items = getters.providerAgreements
        break
      case 'rcm-missing-supports':
        filter.items = getters.providerSupportDocuments
        break
      case 'rcm-responsible-assigned':
        filter.items = getters.users
        break
    }
  })

  commit(SET_FILTERS_CONFIGURATION, filtersByRoleStatusPermissions)
}

const updateSettingsInFilterConfigurations = ({ commit }, payload) => {
  if (payload || payload !== null) {
    commit(SET_FILTERS_CONFIGURATION, payload)
  }
}

const setRolePermissionsStatuses = async ({ commit, rootGetters, dispatch }) => {
  commit(SET_ROLE_PERMISSIONS_LOADING, true)
  showLoader({ dispatch }, true)

  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''

    const response = await getRolePermissionsStatuses(providerSlug)
    const data = camelizeKeys(response.data)
    commit(SET_ROLE_PERMISSIONS_STATUSES, data.roleStatuses)
    commit(SET_ROLE_PERMISSIONS_LOADING, false)

    // Ejecutar todas las llamadas en paralelo
    await Promise.all([
      dispatch('setProviderServiceTypes'),
      dispatch('setProviderExecutorServices'),
      dispatch('setProviderAgreementPlanTypes'),
      dispatch('setProviderInvoiceSources'),
      dispatch('setPayersRcm'),
      dispatch('setProviderAgreements'),
      dispatch('setProviderSupportDocuments'),
      dispatch('setUsers')
    ])

    // Una vez que todas las llamadas paralelas terminen, configurar los filtros
    await dispatch('setFiltersConfiguration')

    showLoader({ dispatch }, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_ROLE_PERMISSIONS_LOADING, false)
    showLoader({ dispatch }, false)
  }
}

const setRolePermissionsAccountRestrictedEvents = async (
  { commit, rootGetters, state, dispatch },
  accountId
) => {
  commit(SET_ROLE_PERMISSIONS_LOADING, true)

  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    const selectedAccount = state.accountDetail.selectedAccount
    const account = selectedAccount.accountId || accountId

    if (account) {
      const response = await getRolePermissionsAccountRestrictedEvents(providerSlug, account)
      commit(SET_ROLE_PERMISSIONS_ACCOUNT_RESTRICTED_EVENTS, camelizeKeys(response.data))
    }

    commit(SET_ROLE_PERMISSIONS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_ROLE_PERMISSIONS_LOADING, false)
  }
}

const setRolePermissionsSupportFileRestrictions = async (
  { commit, rootGetters, state, dispatch },
  accountId
) => {
  commit(SET_ROLE_PERMISSIONS_LOADING, true)

  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    const selectedAccountId = accountId || state.accountDetail.selectedAccount

    const response = await getRolePermissionsSupportFileRestrictions(
      providerSlug,
      selectedAccountId
    )

    commit(SET_ROLE_PERMISSIONS_SUPPORT_FILE_RESTRICTIONS, camelizeKeys(response.data))
    commit(SET_ROLE_PERMISSIONS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_ROLE_PERMISSIONS_LOADING, false)
  }
}

const setSelectedDates = ({ commit }, payload) => {
  commit(SET_SELECTED_DATE, payload)
}

const setSelectedAccount = async ({ commit,dispatch }, accountId) => {
  const response = await getDetailAccount(accountId)
  if(response.data.status === 'ERROR'){
    console.log(response)
    commit(SET_ACCOUNT_CHARGES_LOADING, false)

    const reasonOfChange = response.data.last_change_log?.reason_of_change
    if (reasonOfChange) {
      dispatch(
        'general/configureAlert',
        {
          active: true,
          type: 'error',
          message: reasonOfChange
        },
        { root: true }
      )
    }
  }

  const data = camelizeKeys(response.data)

  if (data.hasUnconfiguredProducts) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t("rcmAccountDetail.labels.pendingProductConfiguration")
      },
      { root: true }
    )
  }

  commit(SET_SELECTED_ACCOUNT, data)
  return data
}

const setAccountCharges = async ({ commit, dispatch, state }, payload) => {
  commit(SET_ACCOUNT_CHARGES_LOADING, true)

  try {
    const selectedAccount = state.accountDetail.selectedAccount
    const accountId = selectedAccount.accountId

    if (accountId) {
      const response = await getAccountCharges(accountId, payload)
      commit(SET_ACCOUNT_CHARGES, camelizeKeys(response.data))
    }

    commit(SET_ACCOUNT_CHARGES_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_ACCOUNT_CHARGES_LOADING, false)
  }
}

const setSupportFilesByCharge = async ({ commit, dispatch, state }, payload) => {
  commit(SET_SUPPORT_FILES_LOADING, true)

  try {
    const selectedAccount = state.accountDetail.selectedAccount
    const accountId = selectedAccount.accountId || payload.accountId

    if (accountId) {
      const response = await getAllSupportFiles(accountId, payload)
      commit(SET_SUPPORT_FILES_BY_CHARGE, {
        response: camelizeKeys(response.data),
        status: payload.statuses
      })
    }

    commit(SET_SUPPORT_FILES_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_SUPPORT_FILES_LOADING, false)
  }
}

const setSupportFilesByAccount = async ({ commit, dispatch, state }, payload) => {
  commit(SET_SUPPORT_FILES_LOADING, true)

  try {
    const selectedAccount = state.accountDetail.selectedAccount
    const accountId = selectedAccount.accountId || payload.accountId

    if (accountId) {
      const response = await getAllSupportFiles(accountId, payload)
      commit(SET_SUPPORT_FILES_BY_ACCOUNT, {
        response: camelizeKeys(response.data),
        status: payload.statuses
      })
    }

    commit(SET_SUPPORT_FILES_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_SUPPORT_FILES_LOADING, false)
  }
}

const setAllSupportFiles = async ({ commit, dispatch, state }, payload) => {
  commit(SET_SUPPORT_FILES_LOADING, true)

  try {
    const selectedAccount = state.accountDetail.selectedAccount
    const accountId = selectedAccount.accountId || payload.accountId

    if (accountId) {
      const response = await getAllSupportFiles(accountId, payload)

      commit(SET_ALL_SUPPORT_DOCUMENT_FILES, {
        response: camelizeKeys(response.data),
        status: payload.statuses
      })
    }

    commit(SET_SUPPORT_FILES_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_SUPPORT_FILES_LOADING, false)
  }
}

const uploadSupportFile = async ({ commit, dispatch }, payload) => {
  commit(SET_SUPPORT_FILES_LOADING, true)
  showLoader({ dispatch }, true)

  try {
    const { supportLevel, file, requestData } = payload

    await uploadSupportFileByEvent(supportLevel, file, requestData)
    showSuccessUploadFileAlert({ dispatch })

    commit(SET_SUPPORT_FILES_LOADING, false);
    showLoader({ dispatch }, false)

    }catch(error){
      dispatch(
          'general/configureAlert',
          {
              active: true,
              type: 'error',
              message: sanitizeEndpointError(error)
          },
          { root: true }
      );

      commit(SET_SUPPORT_FILES_LOADING, false);
      showLoader({ dispatch }, false)
    }
}

const uploadAgreementPMISMatrix = async ({ commit, rootGetters, dispatch }, payload) => {
  const uploadResult = { status: false, errors: [], result: null }
  commit(SET_UPLOAD_AGREEMENT_MATRIX_RESULT_LOADING, true)
  showLoader({ dispatch }, true)

  try {

    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    const { file, processType } = payload

    const response = await uploadAgreementMatrix(file, processType, providerSlug)
    const data = camelizeKeys(response.data)
    uploadResult.status = true
    uploadResult.result = data

    commit(SET_UPLOAD_AGREEMENT_MATRIX_RESULT, uploadResult)
    showSuccessUploadAgreementMatrixFileAlert({ dispatch })

    commit(SET_UPLOAD_AGREEMENT_MATRIX_RESULT_LOADING, false);
    showLoader({ dispatch }, false)

    return uploadResult
  } catch(error) {
    if(error.response){
      if(error.response.data){
        uploadResult.errors = error.response.data.errors
      }
    }

    if (!uploadResult.errors) {
      dispatch(
        'general/configureAlert',
        {
          active: true,
          type: 'error',
          message: sanitizeEndpointError(error)
        },
        { root: true }
      );
    }

    commit(SET_UPLOAD_AGREEMENT_MATRIX_RESULT_LOADING, false);
    showLoader({ dispatch }, false)

    return uploadResult
  }
}

const completeAudit = async ({ commit, getters, dispatch }, file) => {
  commit(SET_SUPPORT_FILES_LOADING, true)
  showLoader({ dispatch }, true)

  try{

    if(file){
      const supportLevel = 'ACCOUNT';

      const requestData = decamelizeKeys({
        accountId: getters.selectedAccount.accountId,
        supportFileCode: 'CONCILIATION_LETTER'
      })

      await uploadSupportFileByEvent(supportLevel, file, requestData)
    }

    await dispatch('setChangeAccountStatus', { next_status: 'COMPLETE_AUDIT' })
    commit(SET_SUPPORT_FILES_LOADING, false);
    showLoader({ dispatch }, false)

  }catch(error){
    dispatch(
      'general/configureAlert',
      {
          active: true,
          type: 'error',
          message: sanitizeEndpointError(error)
      },
      { root: true }
    );

    commit(SET_SUPPORT_FILES_LOADING, false);
    showLoader({ dispatch }, false)
  }
}

const setChangeAccountStatus = async ({ commit, getters, dispatch }, payload) => {
  commit(SET_SUPPORT_FILES_LOADING, true)
  showLoader({ dispatch }, true)

  try {
    const accountId = getters.selectedAccount.accountId

    if(accountId){
      await changeAccountStatus(accountId, payload)
      showLoader({ dispatch }, false)

      const message = payload.message

      showSuccessAccountChangeStatusAlert({dispatch}, message)
      await dispatch('setSelectedAccount', accountId)
    }

    commit(SET_SUPPORT_FILES_LOADING, false)
    showLoader({ dispatch }, false)

  }catch(error){
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    );

    commit(SET_SUPPORT_FILES_LOADING, false);
    showLoader({ dispatch }, false)
  }
}

const setChangeAccountsStatus = async ({ commit, dispatch }, payload) => {
  commit(SET_SELECTED_ACCOUNTS, true)
  showLoader({ dispatch }, true)

  let counter = 0;
  let response = null;
  const accounts = payload.accounts
  try {
    if(accounts){
      const promises = accounts.map(async account => {
        response = await changeAccountStatus(account.id, payload.body);
        if(response.status === 200){
          counter++
        }else{
          dispatch(
            'general/configureAlert',
            {
              active: true,
              type: 'error',
              message: sanitizeEndpointError(response.data)
            },
            { root: true }
          );
        }
      })

      await Promise.all(promises)

      showLoader({ dispatch }, false)
      const message = {
        active: true,
        type: 'success',
        message: payload.message + ` [${vueI18n.t('rcm.accountsAffected')}: ${counter}]`
      }
      const filters = payload.filters

      showSuccessAccountChangeStatusAlert({dispatch}, message)
      await dispatch('getAllAccounts', filters)
    }

    commit(SET_SELECTED_ACCOUNTS, false)
    showLoader({ dispatch }, false)

  }catch(error){
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    );

    commit(ACCOUNTS_LOADING, false);
    showLoader({ dispatch }, false)
  }
}


const deleteSupportFile = async ({ commit, dispatch }, payload) => {
  commit(SET_SUPPORT_FILES_LOADING, true)
  showLoader({ dispatch }, true)

  try {
    const { supportLevel, id } = payload
    await deleteSupportFileByEvent(supportLevel, id)
    showLoader({ dispatch }, false)

    showSuccessDeleteFileAlert({ dispatch })
    commit(SET_SUPPORT_FILES_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_SUPPORT_FILES_LOADING, false)
    showLoader({ dispatch }, false)
  }
}

const showSuccessUploadAgreementMatrixFileAlert = ({ dispatch }) => {
  dispatch(
    'general/configureAlert',
    {
      active: true,
      type: 'success',
      message: vueI18n.t('rcmUploadAgreementMatrix.messages.uploadSuccess')
    },
    { root: true }
  )
}

const getProviderSlug = () => {
  try {
    const { providerSlug = '' } = JSON.parse(localStorage.getItem('tokenExtensions')) || {};
    return providerSlug;
  } catch (error) {
    console.warn('Falling back to default message', error);
    return '';
  }
};

const showSuccessUploadFileAlert = ({ dispatch }) => {
  const providerSlug = getProviderSlug();
  const message = providerSlug.toLowerCase().includes('br')
    ? vueI18n.t('supportFileUploadSuccessBR')
    : vueI18n.t('supportFileUploadSuccess');

  dispatch(
    'general/configureAlert',
    {
      active: true,
      type: 'success',
      message
    },
    { root: true }
  );
};

const showSuccessDeleteFileAlert = ({ dispatch }) => {
  dispatch(
    'general/configureAlert',
    {
      active: true,
      type: 'success',
      message: vueI18n.t('supportFileDeleteSuccess')
    },
    { root: true }
  )
}

const showErrorDate = ({ dispatch }) => {
  dispatch(
    'general/configureAlert',
    {
      active: true,
      type: 'error',
      message: 'error'
    },
    { root: true }
  )
}

const showSuccessAccountChangeStatusAlert = ({ dispatch }, message) => {
  dispatch(
    'general/configureAlert',
    message ? message : {
      active: true,
      type: 'success',
      message: vueI18n.t('rcm.auditComplete')
    },
    { root: true }
  )
}

const showCommentAlert = ({ dispatch }, typeAlert) => {
  const SUCCESS_VALUE = 'success'
  const ERROR_VALUE = 'error'

  let alertConfiguration
  switch (typeAlert) {
    case 'CREATED_COMMENT': {
      alertConfiguration = {
        type: SUCCESS_VALUE,
        message: vueI18n.t('commentsRcm.alertMessages.createdComment')
      }
      break
    }
    case 'EDIT_COMMENT': {
      alertConfiguration = {
        type: SUCCESS_VALUE,
        message: vueI18n.t('commentsRcm.alertMessages.editComment')
      }
      break
    }

    case 'DELETE_COMMENT': {
      alertConfiguration = {
        type: SUCCESS_VALUE,
        message: vueI18n.t('commentsRcm.alertMessages.deleteComment')
      }
      break
    }

    case 'ERROR_COMMENT_MISSING': {
      alertConfiguration = {
        type: ERROR_VALUE,
        message: vueI18n.t('commentsRcm.alertMessages.errorCommentMissing')
      }
      break
    }

    case 'ERROR_DEFAULT_COMMENT': {
      alertConfiguration = {
        type: ERROR_VALUE,
        message: vueI18n.t('commentsRcm.alertMessages.errorDefault')
      }
      break
    }
  }
  dispatch(
    'general/configureAlert',
    {
      active: true,
      type: alertConfiguration.type,
      message: alertConfiguration.message
    },
    { root: true }
  )
}

const setSelectedCharge = async ({ commit }, chargeId) => {
  const response = await getDetailCharge(chargeId)
  const data = camelizeKeys(response.data)
  commit(SET_SELECTED_CHARGE, data)
  return data
}

const setCommentsAccount = async ({ commit }, { accountId, chargeId }) => {
  const response = await getAuditComment(accountId, chargeId)
  const data = camelizeKeys(response.data)
  commit(SET_COMMENTS_ACCOUNT, data)
}

const setAgreements = async ({ commit, dispatch }, payload) => {
  commit(SET_AGRREMENTS_LOADING, true)
  try {
    const response = await getAgreements(payload)
    commit(SET_AGREMENTS, camelizeKeys(response.data))
    commit(SET_AGRREMENTS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_AGRREMENTS_LOADING, false)
  }
}

const setAgreementsV2 = async ({ commit, dispatch }, payload) => {
  commit(SET_AGRREMENTS_LOADING, true)
  try {
    const response = await getAgreementsV2(payload)
    commit(SET_AGREMENTS, camelizeKeys(response.data))
    commit(SET_AGRREMENTS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_AGRREMENTS_LOADING, false)
  }
}

const setPayers = async ({ commit, dispatch }) => {
  commit(SET_AGRREMENTS_LOADING, true)
  try {
    const response = await getPayers()
    commit(SET_PAYERS, camelizeKeys(response.data))
    commit(SET_AGRREMENTS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_AGRREMENTS_LOADING, false)
  }
}

const setSelectedAgreement = ({ commit }, payload) => {
  commit(SET_SELECTED_AGREEMENT, payload)
}

const setAgreementConfiguration = async ({ commit, getters, dispatch }, payload) => {
  commit(SET_AGRREMENTS_LOADING, true)

  try {
    const agreementCode = payload || getters.selectedAgreement.agreementCode

    if (!agreementCode) {
      return
    }

    const response = await getAgreementConfiguration(agreementCode)
    commit(SET_AGREEMENT_CONFIGURATION, camelizeKeys(response.data))
    commit(SET_AGRREMENTS_LOADING, false)

  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_AGRREMENTS_LOADING, false)
  }
}

const setUpdateAgreement = async ({ commit, getters, rootGetters, dispatch }, payload) => {
  commit(SET_AGRREMENTS_LOADING, true)

  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    const agreementCode = getters.agreementConfiguration.agreementCode

    const decamelizePayload = decamelizeKeys({ providerSlug, agreementCode, ...payload })

    await updateAgreement(decamelizePayload)
    showSuccessAgreementUpdate({ dispatch })
    commit(SET_AGRREMENTS_LOADING, false)

  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_AGRREMENTS_LOADING, false)

    throw error
  }
}

const showSuccessAgreementUpdate = ({ dispatch }) => {
  dispatch(
    'general/configureAlert',
    {
      active: true,
      type: 'success',
      message: vueI18n.t('informationSuccessfullyUpdated')
    },
    { root: true }
  )
}

const setSelectedAuditRule = ({ commit }, payload) => {
  commit(SET_SELECTED_AUDIT_RULE, payload)
}

const setHealthcarePlans = async ({ commit, dispatch }) => {
  commit(SET_AGRREMENTS_LOADING, true)

  try {
    const response = await getHealthcarePlans()
    commit(SET_HEALTHCARE_PLANS, camelizeKeys(response.data))
    commit(SET_AGRREMENTS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_AGRREMENTS_LOADING, false)
  }
}

const reSelectAuditRule = ({ commit, getters }) => {
  const selectedAuditRuleId = getters.selectedAuditRule.id
  const auditRule = getters.agreementConfiguration.auditConfigurations.find(
    auditRule => auditRule.id === selectedAuditRuleId
  )

  commit(SET_SELECTED_AUDIT_RULE, auditRule)
}

const setServiceSupportDocuments = async ({ commit, dispatch }, payload) => {
  commit(SET_SERVICE_SUPPORT_DOCUMENTS_LOADING, true)

  try {
    if (payload.level === 'ACCOUNT') {
      const response = await getAgreementServiceSupportDocuments(payload)
      commit(SET_SERVICE_SUPPORT_DOCUMENTS_ACCOUNT, camelizeKeys(response.data))

    } else if (payload.level === 'CHARGE') {
      const response = await getAgreementProductSupportDocuments(payload)

      commit(SET_SERVICE_SUPPORT_DOCUMENTS_CHARGE, {
        response: camelizeKeys(response.data),
        pushNewResults: payload.lastValue ? true : false
      })
    }

    commit(SET_SERVICE_SUPPORT_DOCUMENTS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_SERVICE_SUPPORT_DOCUMENTS_LOADING, false)
  }
}

const setSupportFileTypes = async ({ commit, dispatch }) => {
  try {
    const response = await getSupportFileTypes()
    commit(SET_SUPPORT_FILE_TYPES, camelizeKeys(response.data))
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )
  }
}

const setAgreementProducts = async ({ commit, dispatch }, payload) => {
  commit(SET_AGREEMENT_PRODUCTS_LOADING, true)

  try {

    if(payload.agreementCode){
      const response = await getAgreementProducts(payload)
      commit(SET_AGREEMENT_PRODUCTS, camelizeKeys(response.data))
    }

    commit(SET_AGREEMENT_PRODUCTS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_AGREEMENT_PRODUCTS_LOADING, false)
  }
}
const modifyComment = async ({ dispatch }, { accountId, chargeId, payload }) => {
  try {
    const response = await createOrUpdateComment({ accountId, payload })

    dispatch('setCommentsAccount', { accountId, chargeId })
    const { status } = response
    if (status !== 200) {
      return 'error'
    }
    return 'success'

  } catch (e) {
    dispatch('showCommentAlert', 'ERROR_DEFAULT_COMMENT')
    return 'error'
  }
}

const toggleDialogComment = ({ commit }, payload) => {
  commit(SET_DISPLAY_DIALOG_COMMENT, payload)
}

const setCommentControl = ({ commit }, payload) => {
  commit(SET_COMMENT_CONTROL, payload)
}

const setPayersRcm = async ({ commit }) => {
  const response = await getPayers()
  const data = camelizeKeys(response.data)
  commit(SET_PAYERS_AVAILABLE, data)
}

const validateInvoicedAndConcurrentAccount = ({ commit, state }) => {
  const selectedAccount = state.accountDetail.selectedAccount
  const INVOICED_STATUS_VALUE = 'INVOICED'
  const READY_TO_AUDIT_VALUE = 'PENDING_AUDIT'

  let isConcurrentAccount = false
  let isInvoicedAccount = false
  let isReadyToAudit = false

  if (selectedAccount !== null || typeof selectedAccount !== 'undefined') {
    const { concurrentAuditRequired, status } = selectedAccount
    isConcurrentAccount = concurrentAuditRequired
    isInvoicedAccount = status === INVOICED_STATUS_VALUE ? true : false
    isReadyToAudit = status === READY_TO_AUDIT_VALUE ? true : false
  }

  const payload = {
    isConcurrentAccount,
    isInvoicedAccount,
    isReadyToAudit
  }
  commit(SET_IS_INVOICED_AND_IS_CONCURRENT_ACCOUNT, payload)
}

const setIsMultiPatientAccount = ({commit}, payload) => {
  commit(SET_IS_MULTI_PATIENT_ACCOUNT, payload)
}

const setIsMultiEventSamePatientAccount = ({commit}, payload) => {
  commit(SET_IS_MULTI_EVENT_SAME_PATIENT_ACCOUNT, payload)
}

const showLoader = ({ dispatch }, payload) => {
  dispatch(
    'general/showLoader', payload,
    { root: true }
  )
}

const setProviderServiceTypes = async ({ commit, rootGetters, dispatch }) => {
  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''

    if(providerSlug){
      const response = await getProviderServiceTypes(providerSlug)
      commit(SET_PROVIDER_SERVICE_TYPES, camelizeKeys(response.data))
    }
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t('rcm.errorLoadindServiceTypes')
      },
      { root: true }
    )
  }
}

const setProviderExecutorServices = async ({ commit, rootGetters, dispatch }) => {
  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''

    if(providerSlug){
      const response = await getProviderExecutorServices(providerSlug)
      commit(SET_PROVIDER_EXECUTOR_SERVICES, camelizeKeys(response.data))
    }
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t('rcm.errorLoadindServiceTypes')
      },
      { root: true }
    )
  }
}

const setProviderAgreementPlanTypes = async ({ commit, rootGetters, dispatch }) => {
  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''

    if(providerSlug){
      const response = await getProviderAgreementPlanTypes(providerSlug)
      commit(SET_PROVIDER_AGREEMENT_PLAN_TYPES, camelizeKeys(response.data))
    }
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t('rcm.errorLoadindServiceTypes')
      },
      { root: true }
    )
  }
}

const setProviderInvoiceSources = async ({ commit, rootGetters, dispatch }) => {
  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''

    if(providerSlug){
      const response = await getProviderInvoiceSources(providerSlug)
      commit(SET_PROVIDER_INVOICE_SOURCES, camelizeKeys(response.data))
    }
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t('rcm.errorLoadindServiceTypes')
      },
      { root: true }
    )
  }
}

const setProviderAgreements = async ({ commit, dispatch }) => {
  try {
    const response = await getAllAgreements()
    commit(SET_PROVIDER_AGREEMENTS, camelizeKeys(response.data))
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t('rcm.errorLoadindAgreements')
      },
      { root: true }
    )
  }
}

const setProviderSupportDocuments = async ({ commit, dispatch }) => {
  try {
    const response = await getProviderSupportDocuments()
    commit(SET_PROVIDER_SUPPORT_DOCUMENTS, camelizeKeys(response.data))
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t('rcm.errorLoadindProviderSupportDocuments')
      },
      { root: true }
    )
  }
}

const setAccountListSort = ({ commit }, payload) => {
  commit(SET_ACCOUNT_LIST_SORT, payload)
}

const setAgreementFilters = ({ commit, getters }, payload) => {
  const filtersApplied = [...getters.getAgreementsFilters]
  const newFilters = updateFilter(filtersApplied, payload)

  commit(SET_AGREEMENT_FILTERS, newFilters)
}

const setPreSettlements = async ({ commit, dispatch }, payload) => {
  try {
    const response = await getPreSettlements(payload)
    commit(SET_PRE_SETTLEMENTS, camelizeKeys(response.data))

  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )
  }
}

const setPreSettlementsFilter = ({ commit, getters }, payload) => {
  const filtersApplied = [...getters.preSettlementsFilters]
  const newFilters = updateFilter(filtersApplied, payload);

  commit(SET_PRE_SETTLEMENTS_FILTER, newFilters)
}

const setPreSettlementsDetail = async ({ commit, dispatch }, payload) => {
  try {
    if(!payload) return;

    const response = await getPreSettlementsDetail(payload)
    commit(SET_PRE_SETTLEMENTS_DETAIL, camelizeKeys(response.data))

  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t('rcm.errorLoadindServiceTypes')
      },
      { root: true }
    )
  }
}

const setAccountSearchValue = ({ commit }, payload) => {
  commit(SET_ACCOUNTS_SEARCH_VALUE, payload)
}

const setAccountChargesFilters = ({ commit, getters }, payload) => {
  const filtersApplied = [...getters.localChargesFilters]
  const newFilters = updateFilter(filtersApplied, payload)

  commit(SET_ACCOUNT_CHARGES_FILTER, newFilters)
}

const cleanLocalChargesFilters = ({ commit }) => {
  commit(SET_ACCOUNT_CHARGES_FILTER, [])
}

const setSupportDocuments = async ({ commit, dispatch }) => {
  commit(SET_SUPPORT_DOCUMENTS_LOADING, true)

  try {

    const response = await getSupportFiles()
    commit(SET_SUPPORT_DOCUMENTS, camelizeKeys(response.data))

    commit(SET_SUPPORT_DOCUMENTS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    commit(SET_SUPPORT_DOCUMENTS_LOADING, false)
  }
}

const setSupportFormatFileFields = async ({ commit, dispatch }) => {
  try {
    const response = await getSupportFormatFileFields()
    commit(SET_SUPPORT_FORMAT_FILE_FIELDS, camelizeKeys(response.data))
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t('rcm.errorLoadindServiceTypes')
      },
      { root: true }
    )
  }
}

const setProviderProducts = async ({ commit, rootGetters, dispatch }, payload) => {
  commit(SET_PROVIDER_PRODUCTS_LOADING, true)

  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    const response = await getProviderProducts(providerSlug, payload)
    commit(SET_PROVIDER_PRODUCTS, camelizeKeys(response.data))
    commit(SET_PROVIDER_PRODUCTS_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )
    commit(SET_PROVIDER_PRODUCTS_LOADING, false)

  }
}

const clearProviderProducts = ({ commit }) => {
  commit(SET_PROVIDER_PRODUCTS, [])
}

const setUpdateProviderProducts = async ({ rootGetters }, payload) => {
  const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
  await updateProviderProducts(providerSlug, decamelizeKeys(payload))
}

const setProviderProductSearchValue = ({ commit }, payload) => {
  commit(SET_PROVIDER_PRODUCTS_SEARCH_VALUE, payload)
}

const setProviderProductConfigurationDialog = ({ commit }, payload) => {
  commit(SET_PROVIDER_PRODUCT_CONFIGURATION_DIALOG, payload)
}

const setSelectedProviderProduct = ({ commit }, payload) => {
  commit(SET_SELECTED_PROVIDER_PRODUCT, payload)
}

const setProviderProductConfigurationIndex = ({ commit }, payload) => {
  commit(SET_SELECTED_PROVIDER_PRODUCT_CONFIGURATION, payload)
}

const setAccountDefaultFiltersValuesApplied = ({commit}, payload) => {
  commit(SET_ACCOUNT_DEFAULT_FILTERS_VALUES_APPLIED, payload)
}

const patchPreSettlementFolder = async ({ commit, dispatch }, payload) => {
  commit(SET_AGRREMENTS_LOADING, true)

  try {
    await updatePreSettlementFolder(decamelizeKeys(payload))
    showSuccessAgreementUpdate({ dispatch })
  }catch(error){
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )
  }finally {
    commit(SET_AGRREMENTS_LOADING, false)
  }
}

const setPreSettlementFolderConfiguration = async ({ commit, dispatch }) => {
  try{
    const response = await getPreSettlementFolderConfiguration()
    commit(SET_PRE_SETTLEMENT_FOLDER_CONFIGURATION, camelizeKeys(response.data))
  }catch(error){
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )
  }
}

const setUploadedAgreementMatrix = async ({ commit, rootGetters, dispatch }, payload) => {
  commit(SET_UPLOADED_AGREEMENT_MATRIX_LOADING, true)
  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    const response = await getUploadedAgreementMatrix(providerSlug, payload)
    commit(SET_UPLOADED_AGREEMENT_MATRIX, camelizeKeys(response.data))
    commit(SET_UPLOADED_AGREEMENT_MATRIX_LOADING, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )
    commit(SET_UPLOADED_AGREEMENT_MATRIX_LOADING, false)
  }
}

const setBuildPreSettlement = async ({ dispatch }, payload) => {
  showLoader({ dispatch }, true)

  try {
    const originInvoiceGroupId = payload.originInvoiceGroupId

    if(originInvoiceGroupId){
      await buildPreSettlement(originInvoiceGroupId)

      const message = payload.message

      showSuccessAccountChangeStatusAlert({dispatch}, message)
      await dispatch('setPreSettlementsDetail', originInvoiceGroupId)
    }

    showLoader({ dispatch }, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    showLoader({ dispatch }, false)
  }
}

const setSettlementAction = async ({ dispatch }, { payload, message }) => {
  showLoader({ dispatch }, true)

  try {
    if(payload.action){
      await settlementAction(payload)
      showSuccessAccountChangeStatusAlert({dispatch}, message)
    }

    showLoader({ dispatch }, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    showLoader({ dispatch }, false)
  }
}

const setSettlementStatus = async ({ dispatch }, { originInvoiceGroupId, payload, message }) => {
  showLoader({ dispatch }, true)

  try {
    if(payload.nextStatus){
      await statusPreSettlement(originInvoiceGroupId, payload)
      showSuccessAccountChangeStatusAlert({dispatch}, message)
    }

    showLoader({ dispatch }, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    showLoader({ dispatch }, false)
  }
}

const setUsers = async ({ commit, rootGetters, dispatch }) => {
  try {
    const providerSlug = rootGetters.tokenExtensions.providerSlug || ''
    const response = await getUsers(providerSlug)
    commit(SET_USERS, camelizeKeys(response.data))
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: vueI18n.t('rcm.errorLoadindUsers')
      },
      { root: true }
    )
  }
}

const setAccountResponsible = async ({ dispatch }, payload) => {
  showLoader({ dispatch }, true)

  try {
    await assignAccountResponsible(payload)

    const message = payload.message

    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'success',
        message: message
      },
      { root: true }
    )

    const filters = payload.filters

    await dispatch('getAllAccounts', filters)

    showLoader({ dispatch }, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    showLoader({ dispatch }, false)
  }
}

const uploadSupportFileForPreSettlement = async ({ commit, dispatch }, payload) => {
  commit(SET_SUPPORT_FILES_LOADING, true)
  showLoader({ dispatch }, true)

  try {
    const { id, file  } = payload

    await replaceSupportFileForPreSettlement(id, file)
    showSuccessUploadFileAlert({ dispatch })

    commit(SET_SUPPORT_FILES_LOADING, false);

    }catch(error){
      dispatch(
          'general/configureAlert',
          {
              active: true,
              type: 'error',
              message: sanitizeEndpointError(error)
          },
          { root: true }
      );

      commit(SET_SUPPORT_FILES_LOADING, false);
      showLoader({ dispatch }, false)
    }
}

const setCleanPackageFolder = async ({ dispatch }, payload) => {
  showLoader({ dispatch }, true)

  try {
    await cleanPackageFolder(payload)

    const message = payload.message

    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'success',
        message: message
      },
      { root: true }
    )

    const filters = payload.filters

    await dispatch('getAllAccounts', filters)

    showLoader({ dispatch }, false)
  } catch (error) {
    dispatch(
      'general/configureAlert',
      {
        active: true,
        type: 'error',
        message: sanitizeEndpointError(error)
      },
      { root: true }
    )

    showLoader({ dispatch }, false)
  }
}

export default {
  getAllAccounts,
  setFiltersConfiguration,
  setRolePermissionsStatuses,
  setRolePermissionsAccountRestrictedEvents,
  setRolePermissionsSupportFileRestrictions,
  setSelectedDates,
  setSelectedAccount,
  setAccountCharges,
  setAllSupportFiles,
  setSupportFilesByAccount,
  setSupportFilesByCharge,
  uploadSupportFile,
  deleteSupportFile,
  showErrorDate,
  setSelectedCharge,
  setCommentsAccount,
  setAgreements,
  setAgreementsV2,
  setPayers,
  setSelectedAgreement,
  setAgreementConfiguration,
  setUpdateAgreement,
  modifyComment,
  setSelectedAuditRule,
  setHealthcarePlans,
  reSelectAuditRule,
  setServiceSupportDocuments,
  setSupportFileTypes,
  setAgreementProducts,
  toggleDialogComment,
  setCommentControl,
  showCommentAlert,
  updateSettingsInFilterConfigurations,
  setPayersRcm,
  validateInvoicedAndConcurrentAccount,
  completeAudit,
  setChangeAccountStatus,
  setChangeAccountsStatus,
  showLoader,
  setProviderServiceTypes,
  setProviderExecutorServices,
  setProviderAgreementPlanTypes,
  setProviderInvoiceSources,
  setAccountListSort,
  setAgreementFilters,
  setPreSettlements,
  setPreSettlementsFilter,
  setPreSettlementsDetail,
  setAccountSearchValue,
  setAccountChargesFilters,
  cleanLocalChargesFilters,
  setIsMultiPatientAccount,
  setIsMultiEventSamePatientAccount,
  setSupportDocuments,
  setSupportFormatFileFields,
  setProviderProducts,
  setUpdateProviderProducts,
  setProviderProductSearchValue,
  setProviderProductConfigurationDialog,
  setSelectedProviderProduct,
  setProviderProductConfigurationIndex,
  clearProviderProducts,
  setAccountDefaultFiltersValuesApplied,
	setProviderAgreements,
  patchPreSettlementFolder,
  setPreSettlementFolderConfiguration,
  setUploadedAgreementMatrix,
  uploadAgreementPMISMatrix,
  setProviderSupportDocuments,
  setBuildPreSettlement,
  setSettlementAction,
  setUsers,
  setAccountResponsible,
  setSettlementStatus,
  uploadSupportFileForPreSettlement,
  getAllReassignedAccounts,
  setCleanPackageFolder
}
